module.exports = __webpack_public_path__ + "logo.53343ab28efd427c6a1f.png";


//////////////////
// WEBPACK FOOTER
// /Users/muhammadfiqihfirdiansyah/Documents/Muhammad Fiqih Firdiansyah/Project/Angular/BODES/BODES.Web.UI.Angular4/src/img/logo.png
// module id = ../../../../../src/img/logo.png
// module chunks = styles